import React from 'react';
import { Group } from '../../../../types/communication';
import VariableTextField from '../composition/shared/VariableTextField';
import ToogleSwitch from '../../../atoms/ToogleSwitch';

interface GroupAboutTabProps {
    group: Group;
    name: string;
    description: string;
    isDefault: boolean;
    onNameChange: (value: string) => void;
    onDescriptionChange: (value: string) => void;
    onDefaultChange: (value: boolean) => void;
}

const formatDate = (iso: string | null | undefined) => {
    if (!iso) return '—';
    const date = new Date(iso);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('pt-BR');
};

const GroupAboutTab: React.FC<GroupAboutTabProps> = ({
    group,
    name,
    description,
    isDefault,
    onNameChange,
    onDescriptionChange,
    onDefaultChange,
}) => (
    <div className="flex flex-col gap-4">
        <VariableTextField
            id="group-name"
            label="Nome do grupo"
            value={name}
            maxLength={80}
            hint="Precisa ser único. Espaços e acentos não contam para diferenciar."
            error={!name.trim() ? 'Obrigatório' : undefined}
            onChange={onNameChange}
        />
        <VariableTextField
            id="group-description"
            label="Descrição"
            value={description}
            multiline
            rows={3}
            maxLength={240}
            onChange={onDescriptionChange}
        />
        <div className="flex items-center justify-between rounded-lg border border-gray-200 dark:border-slate-700 px-3 py-2">
            <div className="pr-3">
                <div className="text-sm text-gray-800 dark:text-gray-100">Padrão para novos pontos de contato</div>
                <div className="text-[11px] text-gray-400">
                    Novos contatos nascem elegíveis a este grupo automaticamente.
                </div>
            </div>
            <ToogleSwitch checked={isDefault} onChange={onDefaultChange} />
        </div>
        <div className="text-[11px] text-gray-400">
            Criado em {formatDate(group.createdAt)} · atualizado em {formatDate(group.updatedAt)}
        </div>
    </div>
);

export default GroupAboutTab;
